import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {setupAxios} from "./helper/axiosHelper";
import logger from "react-advanced-logger";
import moment from "moment";
import {env} from "./env";
import {Router} from "react-router-dom";
import {SocketProvider} from "socket.io-react-hooks-advanced";
import history from "./helper/history"

window.moment = moment;


logger.config({
    currentEnv: env.REACT_APP_NODE_ENV,
    envs: ['development', 'staging'],
    minLevel: 'debug',
    prefix: '🪵',
});

setupAxios()
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Router history={history}>
        <SocketProvider
            url={env.SOCKET_IO_URL}
            extraHeaders={{platform: "kh_website"}}
            maxRetries={5}>
            <React.StrictMode>
                <App/>
            </React.StrictMode>
        </SocketProvider>
    </Router>
);
reportWebVitals();
